/** 收付款验证权限码。 */
export const PAYMENT_VALIDATION_PERMISSIONS = {
  access: "payment_validation.collection:access",
  create: "payment_validation.collection:create",
  refund: "payment_validation.collection:refund",
} as const;

/** 付款记录默认分页大小。 */
export const PAYMENT_RECORD_PAGE_SIZE = 10;

/** 二维码付款记录轮询间隔。 */
export const PAYMENT_RECORD_POLL_INTERVAL_MS = 5_000;

/** 卡支付转账可选开户行（常见银行）。 */
export const CARD_PAYMENT_RECEIVE_BANKS = [
  "中信银行",
  "中国工商银行",
  "中国农业银行",
  "中国银行",
  "中国建设银行",
  "交通银行",
  "招商银行",
  "浦发银行",
  "民生银行",
  "兴业银行",
  "光大银行",
  "华夏银行",
  "平安银行",
  "广发银行",
  "邮储银行",
  "北京银行",
  "上海银行",
  "江苏银行",
  "宁波银行",
] as const;
